import {IMucThuTuyenSinhSelectRequest} from "../../model/request/chung-tu-tuyen-sinh/IMucThuTuyenSinhSelectRequest";
import {IProcessRequest} from "../../model/request/IProcessRequest";
import {IDataBIDV} from "../../model/respone/import/IDataBIDV";
import {apiClient} from "../apiClient";

export const MUC_THU_TUYEN_SINH_THI_SINH = "muc-thu-tuyen-sinh-thi-sinh";
export const mucThuTuyenSinhThiSinhApi = {
    SelectBySinhVien: (request: IMucThuTuyenSinhSelectRequest) =>
        apiClient.post(`${MUC_THU_TUYEN_SINH_THI_SINH}/select-by-thisinh`, request),
    ImportBIDV: (request: IProcessRequest<FormData>) =>
        apiClient.upload(
            `${MUC_THU_TUYEN_SINH_THI_SINH}/import-bidv/${request.process_id}`,
            request.payload
        ),
    SaveImportBIDV: (request: IProcessRequest<IDataBIDV[]>) =>
        apiClient.post(
            `${MUC_THU_TUYEN_SINH_THI_SINH}/save-import-bidv/${request.process_id}`,
            request.payload
        ),
};
